import { cn } from "@/lib/utils";
import { motion } from "framer-motion";

interface LoadingProps {
  size?: "sm" | "md" | "lg";
  message?: string;
}

export function MunLoading({ size = "md", message }: LoadingProps) {
  const sizeClasses = {
    sm: "w-8 h-8",
    md: "w-12 h-12",
    lg: "w-16 h-16",
  };

  return (
    <div className="flex flex-col items-center justify-center min-h-[calc(100vh-2rem)] gap-4">
      <motion.div
        className={cn(
          "relative rounded-full border-2 border-primary/20",
          sizeClasses[size]
        )}
        animate={{
          scale: [1, 1.2, 1],
          rotate: [0, 180, 360],
        }}
        transition={{
          duration: 2,
          repeat: Number.POSITIVE_INFINITY,
          ease: "easeInOut",
        }}
      >
        <motion.div
          className="absolute inset-0 rounded-full border-t-2 border-primary"
          animate={{
            rotate: [0, 360],
          }}
          transition={{
            duration: 1.5,
            repeat: Number.POSITIVE_INFINITY,
            ease: "linear",
          }}
        />
        <motion.div
          className="absolute inset-0 rounded-full border-r-2 border-primary/40"
          animate={{
            rotate: [360, 0],
          }}
          transition={{
            duration: 2,
            repeat: Number.POSITIVE_INFINITY,
            ease: "linear",
          }}
        />
      </motion.div>
      {message && <p className="text-lg text-muted-foreground">{message}</p>}
    </div>
  );
}
